import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function RootIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M25.5497 15.0801L22.0296 10.3398C21.0306 8.99805 19.4557 8.20117 17.7808 8.20117H14.2196C12.5448 8.20117 10.964 8.99219 9.97082 10.3398L6.45072 15.0801C5.73965 15.9355 5.88657 17.207 6.77394 17.8809C7.63192 18.5313 8.85426 18.373 9.51244 17.5234L11.5575 14.8867V29.1777C11.5575 30.1855 12.3744 31 13.3851 31C14.3959 31 15.2128 30.1855 15.2128 29.1777V21.7598H16.7818V29.1777C16.7818 30.1855 17.5987 31 18.6094 31C19.6202 31 20.4371 30.1855 20.4371 29.1777V14.8809L22.4821 17.5176C23.1403 18.3672 24.3685 18.5312 25.2206 17.875C26.1139 17.207 26.2608 15.9355 25.5497 15.0801Z"
        fill="currentColor"
      />
      <path
        d="M16.0002 7.44531C17.7853 7.44531 19.2324 6.00248 19.2324 4.22266C19.2324 2.44283 17.7853 1 16.0002 1C14.2152 1 12.7681 2.44283 12.7681 4.22266C12.7681 6.00248 14.2152 7.44531 16.0002 7.44531Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
